export default {
    methods:{
        compareFN(arr,property) {
            var i = 0;
            var j = 0;
            let t;
            for ( i = 0; i < arr.length; i++){
                for (j = 0; j < arr.length; j++){
                    if (arr[i][property] < arr[j][property]){
                        t = arr[i];
                        arr[i] = arr[j];
                        arr[j] = t;
                    }
                }
            }
            return arr
        },
    },
    computed: {
        delayList(){
            return [
                {value:'1',label:'报价延迟'},
                {value:'2',label:'确认报价延迟'},
                {value:'3',label:'建档延迟'},
                {value:'4',label:'采购延迟'},
                {value:'5',label:'发船延迟'},
                {value:'6',label:'入库延迟'},
                {value:'7',label:'销售延迟'},
            ]
        },
        getSource(){
            return [
                {value:'MP',label:'MP'},
                {value:'BU',label:'BU'},
                {value:'Sourcing',label:'Sourcing'},
                {value:'Other',label:'Other'},
            ]
        },
        getRecommendStatus(){
            return [
                {
                    label: '草稿',
                    value: 0,
                    theme:''
                },{
                    label: '待审核',
                    value: 1,
                    theme:'primary'
                },{
                    label: '已审核',
                    value: 2,
                    theme:'success'
                },{
                    label: '已驳回',
                    value: 3,
                    theme:'error'
                },{
                    label: '已取消',
                    value: 4,
                    theme:'warning'
                },
            ]
        },
        getPrimaryStatus(){
            return [
                {
                    label: '草稿',
                    value: 0,
                    theme:''
                },{
                    label: '待审核',
                    value: 1,
                    theme:'success'
                },{
                    label: '待询价',
                    value: 2,
                    theme:'info'
                },{
                    label: '待选择打样工厂',
                    value: 3,
                    theme:'info'
                },{
                    label: '待打样',
                    value: 4,
                    theme:'success'
                },
                {
                    label: '待确认报价',
                    value: 5,
                    theme:'primary'
                },
                {
                    label: '待正式建档',
                    value: 6,
                    theme:'error'
                },
                {
                    label: '已建档',
                    value: 7,
                    theme:'warning'
                },
                {
                    label: '预选产品驳回',
                    value: 8,
                    theme:'error'
                },
                {
                    label: '报价驳回',
                    value: 9,
                    theme:'error'
                },
                {
                    label: '已取消',
                    value: 10,
                    theme:'warning'
                },
                {
                    label: '已删除',
                    value: 11,
                    theme:'error'
                },

            ]
        },
    }
}